import { FilterOutlined } from "@ant-design/icons";
import { FilterButton } from "@components/general/filter_button";
import { PopupCustom } from "@components/general/popup";
import { Spiner } from "@components/loaders/spiner";
import { HomeService } from "@services/home.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { Button, Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { FcFinePrint } from "react-icons/fc";

moment.locale("id");

export const CheckingAccDataPage = () => {
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state
  );
  const [limit, setLimit] = useState<string>("5");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data: laporanUangSaku, isPending: isPendingLaporanUangSaku } =
    useQuery({
      queryKey: [HomeService.queries.GET_DATA_REPORT_BALANCES, nis, limit],
      queryFn: () => HomeService.reportBalances({ nis, limit }),
    });

  useEffect(() => {
    setAppBar({ title: "Rekening Koran", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rekening Koran",
      image: false,
    });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <>
          {/* set filter */}
          <FilterButton
            limit={limit}
            text="data terakhir"
            onFilterClick={() => setPopupFilter(true)}
          />
          {/* end of set filter */}

          {/* report */}
          <div className="tw-mt-8">
            {isPendingLaporanUangSaku && (
              <div className="tw-text-center card-body">
                <Spiner className="" />
              </div>
            )}
            {laporanUangSaku?.data?.length === 0 ? (
              <div className="tw-p-8 tw-text-center card-body">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            ) : (
              (laporanUangSaku?.data ?? [])
                // .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
                // .filter((i) => i.tipe === "keluar")
                // .slice(0, parseInt(limit))
                .sort((a, b) => {
                  // keluar first
                  if (a.tipe === "keluar" && b.tipe !== "keluar") return -1;
                  if (a.tipe !== "keluar" && b.tipe === "keluar") return 1;

                  // if same tipe → sort by date desc
                  return moment(b.tanggal).diff(moment(a.tanggal));
                })
                .map((item, idx) => (
                  <div className="tw-mb-4 card-body" key={idx}>
                    <div className="tw-mb-1 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium tw-text-text-secondary">
                        {moment(item.tanggal ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                      <div className="tw-w-1/3 tw-flex tw-justify-end">
                        {item.tipe === "masuk" ? (
                          <span className="tw-px-2 tw-text-[10px] tw-inline-flex tw-items-center tw-rounded-md tw-bg-blue-50 tw-py-1 tw-font-medium tw-text-blue-700 tw-ring-1 tw-ring-blue-600/10 tw-ring-inset">
                            masuk
                          </span>
                        ) : (
                          <span className="tw-px-2 tw-text-[10px] tw-inline-flex tw-items-center tw-rounded-md tw-bg-red-50 tw-py-1 tw-font-medium tw-text-red-700 tw-ring-1 tw-ring-red-600/10 tw-ring-inset">
                            keluar
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="tw-flex tw-justify-between tw-items-end tw-font-semibold">
                      <div className="tw-text-sm tw-w-[60%] tw-text-text-primary">
                        {item.catatan}
                      </div>
                      <div className="tw-w-[40%] tw-text-end">
                        <div className="tw-text-base tw-text-text-primary">
                          {item.tipe === "masuk"
                            ? toRp(
                                parseFloat(
                                  ((item.uangsakumasuk ?? "") + "").replace(
                                    ",",
                                    ""
                                  ) ?? 0
                                )
                              )
                            : toRp(
                                parseFloat(
                                  ((item.uangkeluar ?? "") + "").replace(
                                    ",",
                                    ""
                                  ) ?? 0
                                )
                              )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            )}
          </div>
          {/* end of report */}
        </>
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <div className="">
          <Select
            className=" tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "5", label: "5 data terakhir" },
              { value: "10", label: "10 data terakhir" },
              { value: "25", label: "25 data terakhir" },
            ]}
          ></Select>
          <Button
            onClick={() => setPopupFilter(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
